import { useGetUserAccessibleOrgsByParamsQuery as _useGetUserAccessibleOrgsByParamsQuery, } from '../generated/graphql-types';
export const useGetUserAccessibleOrgsByParamsQuery = (inputData) => {
    const { data, error, loading, } = _useGetUserAccessibleOrgsByParamsQuery({
        fetchPolicy: 'no-cache',
        variables: {
            inputData,
        },
    });
    return {
        error,
        loading,
        data: data?.getUserAccessibleOrgsByParams,
    };
};
//# sourceMappingURL=orgs-service.js.map